module.exports = __webpack_public_path__ + "static/safello-f09ee2c07a2f54ee5b2908e399a845be.jpeg";